module.exports = function (svg) {
  removeDuplicatedPaths(svg);
  return svg;
};

function removeDuplicatedPaths (element) {
  const paths = [...element.querySelectorAll('path')].map(path => {
    return {
      element: path,
      d: path.getAttribute('d')
    };
  });

  for (let i = 0; i < paths.length; i++) {
    for (let j = 0; j < paths.length; j++) {
      if (j > i && paths[j].d === paths[i].d) {
        const fill1 = paths[i].element.getAttribute('fill');
        const fill2 = paths[j].element.getAttribute('fill');

        const isFill2None = fill2 === 'none' || !fill2;

        if (fill1 && isFill2None) {
          const hasStroke = !!paths[j].element.getAttribute('stroke');
          paths[j].element.setAttribute('fill', hasStroke ? 'transparent' : fill1);
        }

        if (
          paths[i].element.parentNode &&
          !isChildOfClipPath(paths[i].element) &&
          !isChildOfClipPath(paths[j].element) &&
          paths[i].element.outerHTML === paths[j].element.outerHTML
        ) {
          paths[i].element.remove();
        }
      }
    }
  }
}

function isChildOfClipPath (element) {
  return element.parentNode && element.parentNode.tagName === 'clipPath';
}
